import { StyledButton } from './Button.styled';
import React from 'react';

const Button = React.forwardRef((props, ref) => {
  const { children, type } = props;
  const customTypes = [
    'success',
    'error',
    'outlined',
    'dark',
    'important',
    'white',
  ];

  const className = ['old-btn', props.className || ' '];

  if (customTypes.includes(type)) {
    return (
      <StyledButton
        ref={ref}
        {...props}
        type="primary"
        className={[type, ...className].join(' ')}
      >
        {children}
      </StyledButton>
    );
  }

  return (
    <StyledButton ref={ref} {...props} className={className.join(' ')}>
      {children}
    </StyledButton>
  );
});

Button.displayName = 'Button';

export default Button;
